import { breakpoints, colors } from 'style'
import styled from 'styled-components'

export const BookCoverContainer = styled.div`
  height: 100%;
  width: 100%;
  overflow: hidden;
  max-width: 140vh;
  margin: auto;

  .page-view-area {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: row;

    .tools-section {
      background-color: ${colors.white};
      border-radius: 15px;
      height: 100%;
      width: clamp(16.667%, 25%, 300px);
      padding: 1rem;

      &:first-child {
        margin-right: 0.5rem;
      }
      &:last-child {
        margin-left: 0.5rem;
      }
      .cover-section-tabs {
        display: flex;
        margin-bottom: 1rem;
        max-width: 100%;

        .cover-section-tab {
          background-color: ${colors.white};
          color: ${colors.blueDark};
          border-color: ${colors.blueDark};
          text-align: center;
          flex-grow: 1;
          box-shadow: none;

          &:first-child {
            border-radius: 4px 0 0 4px;
            border-left-color: ${colors.blueDark};
          }
          &:last-child {
            border-radius: 0 4px 4px 0;
            border-right-color: ${colors.blueDark};
          }

          &.ant-radio-button-wrapper:not(:first-child)::before {
            background-color: ${colors.blueDark};
          }

          &:hover,
          &.ant-radio-button-wrapper-checked {
            color: ${colors.white};
            background-color: ${colors.blueDark};
          }
          &.ant-radio-button-wrapper-checked:not(
              .ant-radio-button-wrapper-disabled
            )::before {
            background-color: ${colors.blueDark};
          }
        }
      }
    }

    .color-tool {
      display: flex;
      align-items: center;
      margin-right: 20px;

      label {
        margin-left: 1rem;
      }
    }

    .background-controls {
      display: flex;
      flex-direction: column;
      text-align: center;

      .color-input {
        border: none;
        cursor: pointer;

        .swatch {
          width: 100%;
          margin-top: 4px;
        }

        &:focus {
          box-shadow: none;
        }
      }
    }

    .canvas-selector {
      flex-shrink: 0;
    }

    .canvas-area {
      width: 1%;
      height: 100%;
      display: flex;
      flex-grow: 1;
      flex-direction: column;
      padding: 0;
      position: relative;

      .canvas-wrapper {
        border: 1px dashed ${colors.dark4};
        height: 100%;
        min-height: 0;
        min-width: 0;
        max-width: 100%;
        flex: 1 1 auto;
        margin: auto;

        .canvas-container {
          max-height: 100%;
          max-width: 100%;

          canvas {
            max-height: 100%;
            max-width: 100%;
          }
        }
      }
    }

    .file-nav {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 1rem;

      button {
        font-size: 16px;
        width: 83.33%;
        margin-left: 8.33%;
        margin-right: 8.33%;
      }
    }

    .floating-tools {
      position: absolute;
      top: 0;
      z-index: 1;
      background-color: ${colors.white};
      border-radius: 4px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      padding: 8px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      opacity: 0.6;
      transition: opacity 0.3s ease-in-out;
      pointer-events: auto;

      &.ft-left {
        left: 1rem;
      }

      &.ft-right {
        right: 1rem;
      }

      .active-pan {
        color: ${colors.blueDark};
      }

      &:hover {
        opacity: 1;
        transition: opacity 0.3s ease-in-out;
      }
    }
  }

  .zoom {
    width: 3% !important;
  }

  .hidden,
  [hidden] {
    display: none;
  }

  .disabled {
    color: ${colors.dark4};
  }

  .danger {
    background-color: rgba(0, 0, 130, 0.08);
    border-left: 6px solid ${colors.blueDark};
    font-size: 15px;
  }

  @media (max-width: ${breakpoints.sm}px) {
  }
  @media (max-width: 413px), (max-height: 845px) {
    .zoom {
      width: 1% !important;
    }
  }

  .accordion {
    border-radius: 2px;
  }

  .accordion__button {
    color: #444;
    cursor: pointer;
    padding: 1rem 0.5rem;
    width: 100%;
    text-align: left;
    border: none;
  }

  .accordion__button:hover {
    background-color: #ddd;
  }

  .accordion__button:before {
    display: inline-block;
    content: '';
    height: 10px;
    width: 10px;
    margin-right: 12px;
    border-bottom: 2px solid currentColor;
    border-right: 2px solid currentColor;
    transform: rotate(-45deg);
  }

  .accordion__button[aria-expanded='true']::before,
  .accordion__button[aria-selected='true']::before {
    transform: rotate(45deg);
  }

  .accordion__panel {
    padding-left: 1.5rem;
    animation: fadein 0.35s ease-in;
  }

  .add-img-panel {
    label {
      font-size: 14px;
    }

    .img-url-input {
      max-width: 100%;
    }

    .img-upload {
      visibility: hidden;
      max-width: 120px;

      &::file-selector-button {
        visibility: visible;
        height: 25px;
        border-radius: 5px;
        font-size: 15px;
        padding: 0px 16px;
        background-color: rgb(0, 0, 130);
        border: 2px solid rgb(0, 0, 130);
        color: ${colors.white};

        &:hover {
          background-color: rgb(255, 255, 255);
          color: rgb(0, 0, 130);
          border: 2px solid rgb(0, 0, 130);
          cursor: pointer;
        }
      }
    }
  }

  /* -------------------------------------------------- */
  /* ---------------- Animation part ------------------ */
  /* -------------------------------------------------- */

  @keyframes fadein {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }
`
